import Generator from '../generator';
export default new Generator('menus').createEntityModel();
